/* <!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-21 13:10:52
 * @FilePath: /mrc_ess_web_fronted/src/Page/Ess/Leave/LeaveApplication/newLeaveApplication.vue
 * @最后编辑: Betway
 * @最后修改时间: 2020-11-04 17:56:37
-->
<template>
  <ContentLayout
    :title="$t('label_essweb_leaveApplication_form_newTitle')"
    pad="0"
    :initData="ApplicationData"
    @change="(changed) => (isChanged = changed)"
    :checkData="['leave_reason_uuid', 'leave_transaction_type_uuid', 'remarks']"
    widthClass="max-1000"
    backgroundClass="transparent"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper" contentClass="pa-0 white">
        <template v-slot:content-1>
          <noContent v-if="!NoticeList" />
          <v-sheet class="pa-8 rounded-t-lg" v-if="NoticeList">
            <span class="text-h4">{{
              $t(
                "label_essweb_myLeaveApplication_form_step_applicationNotesLabel"
              )
            }}</span>
            <v-list-item v-if="NoticeList.f1">
              <v-list-item-icon>
                <!-- <span class="material-icons-round">send</span> -->
                <span class="material-icons-round md-24"
                  >fiber_manual_record</span
                >
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                {{ $getCommonLangValue(NoticeList.f1) }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="NoticeList.f2">
              <v-list-item-icon>
                <span class="material-icons-round md-24"
                  >fiber_manual_record</span
                >
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                {{ $getCommonLangValue(NoticeList.f2) }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="NoticeList.f3">
              <v-list-item-icon>
                <span class="material-icons-round md-24"
                  >fiber_manual_record</span
                >
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                {{ $getCommonLangValue(NoticeList.f3) }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-if="NoticeList.f4">
              <v-list-item-icon>
                <span class="material-icons-round md-24"
                  >fiber_manual_record</span
                >
              </v-list-item-icon>
              <v-list-item-content class="pl-2">
                {{ $getCommonLangValue(NoticeList.f4) }}
              </v-list-item-content>
            </v-list-item>
            <!-- bug1533 brain 不显示这个-->
            <!-- <v-sheet
              class="pl-3 rounded-xl mt-5"
              style="border: 1px solid var(--main-border-color)"
            >
              <v-checkbox
                v-model="showAgain"
                :label="
                  $t('label_essweb_myLeaveApplication_form_stopShowAgain')
                "
                required
              ></v-checkbox>
            </v-sheet> -->
          </v-sheet>
        </template>
        <template v-slot:content-2>
          <v-card class="transparent pa-0" :elevation="0" v-if="CurleaveType">
            <v-card-text class="pa-0 mrc-grey">
              <v-sheet
                color="primary"
                class="pt-1 rounded rounded-b-lg"
                v-if="false"
              >
                <v-card class="elevation-0 mb-4 rounded-b" tile>
                  <v-card-text
                    class="
                      d-flex
                      flex-column
                      justify-space-between
                      pa-3
                      white--text
                    "
                  >
                    <div class="text-left text-h6 text--primary">
                      {{ $getCommonLangValue(CurleaveType["leave_type_name"]) }}
                    </div>
                    <div
                      class="
                        text-right
                        title
                        text--primary
                        d-flex
                        align-center
                        justify-end
                      "
                      v-if="Number(CurleaveType['is_show_pending'])"
                    >
                      <span class="d-inline-block text-h2">{{
                        leaveBalance
                      }}</span>
                      <span class="d-inline-block text-caption mx-2"
                        >{{
                          CurleaveType["unit"] === "D"
                            ? $t("label_essweb_system_dayLabel")
                            : $t("label_essweb_system_hourLabel")
                        }}
                      </span>
                    </div>
                    <div
                      class="text-right text-caption text--secondary"
                      v-if="Number(CurleaveType['is_show_pending'])"
                    >
                      {{
                        $t("label_essweb_myLeaveApplication_form_pendingLabel")
                      }}:
                      {{
                        CurleaveType["leave_pending"] +
                        (CurleaveType["unit"] === "D"
                          ? $t("label_essweb_system_dayLabel")
                          : $t("label_essweb_system_hourLabel"))
                      }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-sheet>
              <v-sheet class="rounded-t-lg white pa-8 mt-8">
                <v-form ref="form" lazy-validation>
                  <v-row>
                    <v-col xs="12" sm="6" :md="6" :lg="6" cols="12">
                      <AutoComplete
                        label="label_essweb_leaveApplication_form_leaveTypeLabel"
                        v-model="ApplicationData.leave_type_uuid"
                        :items="leaveType"
                        :rules="$GetRules(['_Require_Rules'], [null])"
                        disabled
                        item-value="value_field"
                        item-text="view_fields"
                      >
                      </AutoComplete>
                    </v-col>
                    <v-col xs="12" sm="6" :md="6" :lg="6" cols="12">
                      <AutoComplete
                        isRequired
                        label="label_essweb_leaveApplication_form_leaveTransactionTypeLabel"
                        v-model="ApplicationData.leave_transaction_type_uuid"
                        :items="leaveTransactionType"
                        :rules="$GetRules(['_Require_Rules'], [null])"
                        :key="`${defaultLang}--leave_transaction_type_uuid`"
                        item-value="uuid"
                        item-text="leave_transaction_type_name"
                      >
                      </AutoComplete>
                    </v-col>
                    <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                      <AutoComplete
                        isRequired
                        label="label_essweb_leaveApplication_form_leaveReasonLabel"
                        v-model="ApplicationData.leave_reason_uuid"
                        :items="leaveReason"
                        :rules="$GetRules(['_Require_Rules'], [null])"
                        :mrc-key="`${defaultLang}--leave_reason_uuid`"
                        item-value="value_field"
                        item-text="view_fields"
                      >
                      </AutoComplete>
                      <v-text-field
                        filled
                        dense
                        :placeholder="
                          $t(
                            'label_essweb_LeaveApplication_form_fillReasonLabel'
                          )
                        "
                        v-if="ApplicationData.leave_reason_uuid === 'other'"
                        single-line
                        v-model="ApplicationData.leave_reason_text"
                      ></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12" :key="refreshKey">
                      <v-sheet class="mrc_text_require text--secondary">{{
                        $t("label_essweb_LeaveApplication_form_leaveTimeLabel")
                      }}</v-sheet>
                      <DateTimePicker
                        isRequire
                        :disabled="logic == -1"
                        url_type="admin"
                        v-if="logic == -1"
                        type="onedatetimerange"
                        :value="dateTerminal"
                        :defaultStartTime="defaultStartDate"
                        :defaultEndTime="defaultEndDate"
                        :placeholder="
                          $t('label_essweb_RosterRecord_list_seTimeLabel')
                        "
                        @change="
                          (time, isre) => {
                            dateTerminal = time;
                            if (isre) {
                              defaultStartDate = time
                                ? time.split(' - ')[0]
                                : '';
                              defaultEndDate = time ? time.split(' - ')[1] : '';
                            }
                          }
                        "
                      />
                      <DateTimePicker
                        isRequire
                        v-if="logic == 4"
                        url_type="admin"
                        type="daterange"
                        :value="dateTerminal"
                        :defaultStartTime="defaultStartDate"
                        :defaultEndTime="defaultEndDate"
                        :placeholder="
                          $t('label_essweb_RosterRecord_list_seTimeLabel')
                        "
                        @change="
                          (time, isre) => {
                            dateTerminal = time;
                            if (isre) {
                              defaultStartDate = time
                                ? time.split(' - ')[0]
                                : '';
                              defaultEndDate = time ? time.split(' - ')[1] : '';
                            }
                          }
                        "
                      />
                      <DateTimePicker
                        isRequire
                        v-if="logic == 3"
                        type="dateapm"
                        url_type="admin"
                        :value="dateTerminal"
                        :defaultStartTime="defaultStartDate"
                        :defaultEndTime="defaultEndDate"
                        :placeholder="
                          $t('label_essweb_RosterRecord_list_seTimeLabel')
                        "
                        @change="
                          (time, isre) => {
                            dateTerminal = time;
                            if (isre) {
                              defaultStartDate = time
                                .split(' - ')[0]
                                .split(' ')[0];
                              defaultEndDate = time
                                .split(' - ')[1]
                                .split(' ')[0];
                            }
                          }
                        "
                      />
                      <DateTimePicker
                        isRequire
                        v-if="logic == 1"
                        :staff_uuid="page_params.staff_uuid"
                        :leave-transaction-type-code="
                          ApplicationData.leave_transaction_type_code
                        "
                        url_type="admin"
                        type="day30min"
                        :TimeType="
                          Number(
                            propertys['is_allow_apply|is_apply_as_n_minutes'][
                              'value'
                            ]
                          )
                        "
                        :startTime="0"
                        :endTime="1440"
                        :value="dateTerminal"
                        :defaultStartTime="defaultStartDate"
                        :defaultEndTime="defaultEndDate"
                        :placeholder="
                          $t('label_essweb_RosterRecord_list_seTimeLabel')
                        "
                        @change="
                          (time, isre) => {
                            dateTerminal = time;
                            if (isre) {
                              defaultStartDate = time
                                ? time.split(' - ')[0]
                                : '';
                              defaultEndDate = time ? time.split(' - ')[1] : '';
                            }
                          }
                        "
                      />
                      <DateTimePicker
                        isRequire
                        url_type="admin"
                        v-if="logic == 2"
                        type="daytime"
                        :staff_uuid="page_params.staff_uuid"
                        :leave-transaction-type-code="
                          ApplicationData.leave_transaction_type_code
                        "
                        :value="dateTerminal"
                        :defaultStartTime="defaultStartDate"
                        :defaultEndTime="defaultEndDate"
                        :placeholder="
                          $t('label_essweb_RosterRecord_list_seTimeLabel')
                        "
                        @change="
                          (time, isre) => {
                            dateTerminal = time;
                            if (isre) {
                              defaultStartDate = time
                                ? time.split(' - ')[0]
                                : '';
                              defaultEndDate = time ? time.split(' - ')[1] : '';
                            }
                          }
                        "
                      />
                      <DateTimePicker
                        isRequire
                        v-if="logic == 0"
                        url_type="admin"
                        type="day15min"
                        :TimeType="
                          Number(
                            propertys[
                              'is_allow_apply|is_apply_as_frontend_unit_as_minutes'
                            ]['value']
                          )
                        "
                        :startTime="0"
                        :staff_uuid="page_params.staff_uuid"
                        :leave-transaction-type-code="
                          ApplicationData.leave_transaction_type_code
                        "
                        :endTime="1440"
                        :value="dateTerminal"
                        :defaultStartTime="defaultStartDate"
                        :defaultEndTime="defaultEndDate"
                        :placeholder="
                          $t('label_essweb_RosterRecord_list_seTimeLabel')
                        "
                        @change="
                          (time, isre) => {
                            dateTerminal = time;
                            if (isre) {
                              defaultStartDate = time
                                ? time.split(' - ')[0]
                                : '';
                              defaultEndDate = time ? time.split(' - ')[1] : '';
                            }
                          }
                        "
                      />
                    </v-col>
                    <v-col sm="6" cols="12" :key="refreshKey2">
                      <v-sheet class="text--secondary">{{
                        $t("label_essweb_LeaveApplication_form_applyAsLabel")
                      }}</v-sheet>
                      <v-text-field
                        filled
                        disabled
                        dense
                        single-line
                        :value="
                          ApplicationData.showTime | getCostTime(getCostTime2)
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col sm="6" cols="12" md="6">
                      <v-sheet class="text--secondary">{{
                        $t("label_essweb_leaveApplication_form_attachmentLabel")
                      }}</v-sheet>
                      <ImgDragUpdate @change="onInputImage" />
                    </v-col>
                    <!-- <v-col cols="12">
                      <normalInputTextFiled
                        v-model="ApplicationData.remarks"
                        :label="
                          $t('label_essweb_leaveApplication_form_messageLabel')
                        "
                      />
                    </v-col> -->
                  </v-row>
                </v-form>
              </v-sheet>
            </v-card-text>
          </v-card>
        </template>
      </Stepper>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        v-if="iSEdited"
        :submitBtn="step == curStep && curStep != 0 ? true : false"
        :step="step == curStep ? false : true"
        @next="toNext"
        :onLoading="isLoading"
        @submit="toNew()"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- tools -->
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newLeaveApplication",
  components: {},
  computed: {
    ...mapGetters([
      "companyLang",
      "defaultUTC",

      "AppInfo",
      "isLoading",
      "defaultLang",
    ]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },

    logic() {
      if (!this.myLogic) return -1;
      return this.queryKey.indexOf(
        this.myLogic["leave_transaction_type_property_master_code"].toString()
      );
      // 4，按天请假，3,按半天请假，1，30分钟，2.小时，0，15分钟
    },
  },
  watch: {
    showAgain(val) {
      localStorage.setItem(
        "mrc-ess-application-leve-tips-show-again",
        val.toString()
      );
    },
    dateTerminal(val) {
      this.ApplicationData.showTime = null;
      if (val) {
        this.getCost();
      }
    },
    myLogic(val) {},
    "ApplicationData.leave_type_uuid": function (val) {
      const that = this;
      that.leaveTransactionType.some((item) => {
        if (Number(item.is_default)) {
          that.ApplicationData.leave_transaction_type_uuid = item.uuid;
          that.ApplicationData.leave_transaction_type_code =
            item.leave_transaction_type_code;
          return true;
        } else {
          that.ApplicationData.leave_transaction_type_uuid =
            that.leaveTransactionType[0].uuid;
          that.ApplicationData.leave_transaction_type_code =
            that.leaveTransactionType[0].leave_transaction_type_code;
          return false;
        }
      });
      this.getTransactionLeaveType(val);
    },
    "ApplicationData.leave_reason_uuid": function (val) {
      // if (val === "other") {
      //   this.ApplicationData.leave_reason_text = "";
      // } else {
      //   this.ApplicationData.leave_reason_text = this.leaveReason.find(
      //     (ele) => {
      //       ele.value_field === val;
      //     }
      //   )["view_fields"];
      // }
    },
    "ApplicationData.leave_transaction_type_uuid": function (val) {
      this.refreshKey = Math.random() * 100000000;
      this.refreshKey2 = Math.random() * 100000000;
      this.ApplicationData.showTime = null;
      this.dateTerminal = "";
      if (val) {
        this.ApplicationData.leave_transaction_type_code =
          this.leaveTransactionType.find((ele) => ele.uuid == val)[
            "leave_transaction_type_code"
          ];
        this.getLogic(val);
        this.getProperty(val);
      } else {
        this.ApplicationData.leave_transaction_type_code = "";
      }
    },
  },
  data() {
    return {
      curStep: 1,
      step: 2,
      isChanged: false,
      NoticeList: null,

      iSEdited: false,
      showAgain: false,
      stepper: [
        "label_essweb_myLeaveApplication_form_step_applicationNotesLabel",
        "label_essweb_myLeaveApplication_form_step_applicationFormLabel",
      ],
      leaveType: [],
      CurleaveType: null,
      leaveReason: [],
      propertys: {
        "is_allow_apply|is_apply_as_frontend_unit_as_minutes": {
          value: 60,
        },
        "is_allow_apply|is_apply_as_n_minutes": {
          value: 60,
        },
      },
      queryKey: [
        "is_allow_apply|is_apply_as_frontend_unit_as_minutes", //is_apply_as_15_minutes
        "is_allow_apply|is_apply_as_n_minutes", //is_apply_as_30_minutes
        "is_allow_apply|is_apply_as_full_hour",
        "is_allow_apply|is_apply_as_half_day",
        "is_allow_apply|is_apply_as_day",
      ],
      curStaff: null,
      myLogic: null,
      page_params: null,
      leaveBalance: 0,
      curUnit: "",
      refreshKey: "123",
      refreshKey2: "dfdf",
      dateTerminal: "",
      defaultStartDate: "",
      defaultEndDate: "",
      leaveTransactionType: [],
      ApplicationData: {
        leave_type_uuid: "",
        leave_transaction_type_uuid: "",
        leave_transaction_type_code: "",
        leave_reason_uuid: "",
        leave_reason_text: "",
        start_utc_datetime: "",
        start_time_time_zone: "",
        end_utc_datetime: "",
        data_json: "",
        end_time_time_zone: "",
        total_minutes: "",
        number_of_day: "",
        number_of_minutes: "",
        leaveTimeType: "",
        remarks: "",
        showTime: "",
        sender_uuid: "",
        attachment_uuid: [],
      },
    };
  },
  mounted() {
    const that = this;
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.args));
    this.ApplicationData.start_time_time_zone = this.defaultUTC;
    this.ApplicationData.end_time_time_zone = this.defaultUTC;
    this.curStaff = this.page_params.staff_uuid;
    this.getNotice();
    this.getLeaveTypeDetail();
    this.getTransactionLeaveType(this.page_params.leave_type_uuid);
    this.getLeaveType();
    this.getLeaveReason();
    this.showAgain = localStorage.getItem(
      "mrc-ess-application-leve-tips-show-again"
    )
      ? localStorage.getItem("mrc-ess-application-leve-tips-show-again")
      : "false";
    this.showAgain = this.showAgain === "true" ? true : false;
    that.iSEdited = true;

    if (this.showAgain) {
      this.curStep = 2;
    }
  },
  filters: {
    getCostTime(time, callback) {
      return callback(time);
    },
  },
  methods: {
    getProperty: function (trans) {
      const that = this;
      that
        .$Request({
          method: "POST",
          table: "ess_lv_leave_transaction_type_property_master",
          url: "/leave/get-leave-transaction-type-propertys/",
          data: {
            leave_transaction_type_uuid: trans,
            codes:
              "is_allow_apply,is_allow_apply|is_allow_apply_before_leave_date,is_allow_apply|is_allow_apply_before_leave_date|apply_days_earliest_before_leave_date,is_allow_apply|is_allow_apply_before_leave_date|apply_days_latest_before_leave_date,is_allow_apply|is_allow_apply_before_leave_date|file_attachment_is_required_from_date_before,is_allow_apply|is_allow_apply_after_leave_date,is_allow_apply|is_allow_apply_after_leave_date|apply_days_after_leave_date,is_allow_apply|is_allow_apply_after_leave_date|file_attachment_is_required_after_leave_date,is_allow_apply|file_attachment_is_required_if_total_days_more_than,is_allow_apply|apply_minimum_days,is_allow_apply|apply_maximum_days,is_allow_apply|is_show_team_leave_schedule,is_allow_apply|is_allow_file_attachment,is_allow_apply|is_apply_as_day,is_allow_apply|is_apply_as_half_day,is_allow_apply|is_apply_as_full_hour,is_allow_apply|is_apply_as_full_hour|apply_minimum_minutes,is_allow_apply|is_apply_as_frontend_unit_as_minutes,is_allow_apply|is_apply_as_n_minutes,is_allow_apply|is_allow_cancellation,is_allow_apply|is_allow_cancellation|cancellation_before_approval_days_before_leave_date,is_allow_apply|is_allow_cancellation|cancellation_before_approval_days_after_leave_date,is_allow_apply|is_allow_cancellation|cancellation_after_approval_days_before_leave_date,is_allow_apply|is_allow_cancellation|cancellation_after_approval_days_after_leave_date,is_allow_apply|require_cancellation_remarks,is_check_balance,is_apply_as_day_unit,is_allow_entry,is_expiry,is_expiry|expiry_day_after,leave_period_in_months,leave_period_not_in_months,leave_period_in_birthday_month,is_affect_attendance",
          },
          type: "client",
        })
        .then((res) => {
          for (let key in res.data) {
            if (res.data[key] === null) {
              res.data[key] = { value: null };
            }
          }
          that.propertys = res.data;
        });
    },
    getCostTime2: function (time) {
      if (time == null) return "";
      const that = this;
      if (time["unit"] === "D") {
        return (
          that.$getDateTime(time.start_utc_datetime, "YYYY/MM/DD HH:mm") +
          " - " +
          that.$getDateTime(time.end_utc_datetime, "YYYY/MM/DD HH:mm") +
          "(" +
          parseFloat(
            (
              Number(time.total_leave_minutes) /
              Number(time.standard_working_minutes)
            ).toFixed(4)
          ) +
          that.$t("label_essweb_system_dayLabel") +
          ")"
        );
      } else if (time["unit"] === "H") {
        return (
          that.$getDateTime(time.start_utc_datetime, "YYYY/MM/DD HH:mm") +
          " - " +
          that.$getDateTime(time.end_utc_datetime, "YYYY/MM/DD HH:mm") +
          "(" +
          parseFloat((Number(time.total_leave_minutes) / 60).toFixed(4)) +
          that.$t("label_essweb_system_hourLabel") +
          ")"
        );
      } else {
        return "";
      }
    },
    getNotice: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_leave_type_notice_select",

        leave_type_uuid: this.page_params.leave_type_uuid,
      }).then((res) => {
        that.NoticeList = res.data[0];
        if (
          !(
            that.NoticeList.f1 ||
            that.NoticeList.f2 ||
            that.NoticeList.f3 ||
            that.NoticeList.f4 ||
            that.NoticeList.f5
          )
        )
          that.toNext();
      });
    },
    getLogic: function (uuid) {
      const that = this;
      that.myLogic = null;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_transaction_type_property_master",
        url: "/leave/get-leave-transaction-type-propertys/",
        data: {
          leave_transaction_type_uuid: uuid,
          codes:
            "is_allow_apply|is_apply_as_frontend_unit_as_minutes,is_allow_apply|is_apply_as_full_hour,is_allow_apply|is_apply_as_half_day,is_allow_apply|is_apply_as_day",
        },
        // type: "client",
      }).then((res) => {
        for (let key in res.data) {
          if (that.queryKey.indexOf(key.toString()) != -1) {
            if (res.data[key] && Number(res.data[key]["value"])) {
              if (!that.myLogic) that.myLogic = res.data[key]; //取第一个
            }
          }
        }
      });
    },
    getCost: function () {
      const that = this;
      let leaveTimeType = {};
      let arr = [
        "frontend_unit_as_minutes",
        "n_minutes",
        "full_hour",
        "half_day",
        "day",
      ];
      // 0,15分钟,1,30分钟,2.小时,3,按半天请假4，按天请假
      leaveTimeType["type"] = arr[this.logic];
      if (leaveTimeType["type"] == "half_day") {
        leaveTimeType["params"] = {
          startTime: this.dateTerminal.split(" - ")[0].split(" ")[1],
          endTime: this.dateTerminal.split(" - ")[1].split(" ")[1],
        };
      }
      if (leaveTimeType["type"] === "day") {
        this.defaultEndDate = this.defaultEndDate + " 23:59:59";
        // this.defaultStartDate = this.defaultStartDate + " 00:00:00";
      }
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave/get-leave-cost/",
        data: {
          start_utc_datetime: this.$getTimeValue(
            this.defaultStartDate,
            "leave"
          ),
          applicant_staff_uuid: this.page_params.staff_uuid,
          end_utc_datetime: this.$getTimeValue(this.defaultEndDate, "leave"),
          leave_type_uuid: this.ApplicationData.leave_type_uuid,
          leave_transaction_type_uuid:
            this.ApplicationData.leave_transaction_type_uuid,
          leave_time_type: leaveTimeType,
        },
        // type: "client",
      }).then((res) => {
        that.ApplicationData.data_json = JSON.stringify(res.data);
        that.ApplicationData.showTime = {
          start_utc_datetime: res.data.start_utc_datetime,
          end_utc_datetime: res.data.end_utc_datetime,
          total_leave_minutes: res.data.total_leave_minutes,
          standard_working_minutes: res.data.standard_working_minutes,
          unit: that.curUnit,
        };
        // that.$getDateTime(res.data.start_utc_datetime, "YYYY/MM/DD HH:mm") +
        // " - " +
        // that.$getDateTime(res.data.end_utc_datetime, "YYYY/MM/DD HH:mm") +
        // "(" +
        // this.$timeMachine(
        //   Number(res.data.total_leave_minutes),
        //   true,
        //   res.data.standard_working_minutes
        // ) +
        // ")";
      });
    },
    getLeaveTypeDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave/get-vacation-balance/",
        data: {
          staff_uuid: this.page_params.staff_uuid,
          leave_type_uuid: this.page_params.leave_type_uuid,
        },
        // type: "client",
      }).then((res) => {
        that.CurleaveType = res.data["ess_lv_leave_balance"][0];
        that.curUnit = res.data["ess_lv_leave_balance"][0]["unit"];
        if (that.CurleaveType["unit"] === "D") {
          if (res.data["ess_lv_leave_balance"]) {
            if (
              res.data["ess_lv_leave_balance"][0]["leave_balance"] ==
              Number(res.data["standard_working_minutes"])
            ) {
              that.leaveBalance =
                res.data["ess_lv_leave_balance"][0]["leave_balance"] /
                Number(res.data["standard_working_minutes"]);
            } else {
              that.leaveBalance = parseFloat(
                (
                  Number(res.data["ess_lv_leave_balance"][0]["leave_balance"]) /
                  Number(res.data["standard_working_minutes"])
                ).toFixed(4)
              );
            }
            if (res.data["ess_lv_leave_balance"][0]["leave_balance"] == 0) {
              that.leaveBalance = 0;
            }
            // if (
            //   res.data["ess_lv_leave_balance"][0]["leave_balance"] <
            //   Number(res.data["standard_working_minutes"])
            // ) {
            //   that.leaveBalance =
            //     res.data["ess_lv_leave_balance"][0]["leave_balance"] +
            //     that.$t("label_essweb_system_minutesLabel");
            // }
          }
        } else {
          if (res.data["ess_lv_leave_balance"]) {
            if (res.data["ess_lv_leave_balance"][0]["leave_balance"] == 60) {
              that.leaveBalance =
                res.data["ess_lv_leave_balance"][0]["leave_balance"] / 60;
            } else {
              that.leaveBalance = parseFloat(
                (
                  Number(res.data["ess_lv_leave_balance"][0]["leave_balance"]) /
                  60
                ).toFixed(4)
              );
            }
          }
        }
        if (that.CurleaveType["unit"] === "D") {
          if (res.data["ess_lv_leave_balance"]) {
            if (
              res.data["ess_lv_leave_balance"][0]["leave_pending"] ==
              Number(res.data["standard_working_minutes"])
            ) {
              res.data["ess_lv_leave_balance"][0]["leave_pending"] =
                Number(res.data["ess_lv_leave_balance"][0]["leave_pending"]) /
                Number(res.data["standard_working_minutes"]);
            } else {
              res.data["ess_lv_leave_balance"][0]["leave_pending"] = parseFloat(
                (
                  Number(res.data["ess_lv_leave_balance"][0]["leave_pending"]) /
                  Number(res.data["standard_working_minutes"])
                ).toFixed(4)
              );
            }
          }
          if (res.data["ess_lv_leave_balance"][0]["leave_pending"] == 0) {
            res.data["ess_lv_leave_balance"][0]["leave_pending"] = 0;
          }
        } else {
          if (res.data["ess_lv_leave_balance"]) {
            if (res.data["ess_lv_leave_balance"][0]["leave_pending"] == 60) {
              res.data["ess_lv_leave_balance"][0]["leave_pending"] =
                Number(res.data["ess_lv_leave_balance"][0]["leave_pending"]) /
                60;
            } else {
              res.data["ess_lv_leave_balance"][0]["leave_pending"] = parseFloat(
                (
                  Number(res.data["ess_lv_leave_balance"][0]["leave_pending"]) /
                  60
                ).toFixed(4)
              );
            }
          }
        }
        that.ApplicationData.leave_type_uuid =
          res.data["ess_lv_leave_balance"][0]["leave_type_uuid"];
      });
    },
    getTimeTer: function (start, end) {
      if (!start || !end) return "";
      let ter = parseInt(
        (new Date(end).getTime() - new Date(start).getTime()) / 1000 / 60
      );
      return start + " - " + end + "(" + this.$timeMachine(ter, true) + ")";
    },
    getLeaveType: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_leave_type_select",
      }).then((res) => {
        that.leaveType = res.data;
      });
    },
    getTransactionLeaveType: function (leavetype) {
      const that = this;
      // 2021-07-29 BJ 修改接口
      // this.$findPrompt({
      //
      //   prompt_name: "ess_leave_transaction_type_select",
      //   leave_type_uuid: leavetype,

      //   global: false,
      // }).then((res) => {
      //   that.leaveTransactionType = res.data;
      // });
      this.$Request({
        method: "POST",
        table: "x",
        url: "/leave/get-leave-transaction-type/",
        data: {
          leave_type_uuid: leavetype,
          staff_uuid: this.page_params.staff_uuid,
        },
        // type: "client",
      }).then((res) => {
        that.leaveTransactionType = res.data;
        if (that.leaveTransactionType.length)
          res.data.some((item) => {
            if (Number(item.is_default)) {
              that.ApplicationData.leave_transaction_type_uuid = item.uuid;
              that.ApplicationData.leave_transaction_type_code =
                item.leave_transaction_type_code;
              return true;
            } else {
              that.ApplicationData.leave_transaction_type_uuid =
                that.leaveTransactionType[0].uuid;
              that.ApplicationData.leave_transaction_type_code =
                that.leaveTransactionType[0].leave_transaction_type_code;
              return false;
            }
          });
      });
    },
    getLeaveReason: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_leave_type_reason_select",
        leave_type_uuid: this.page_params.leave_type_uuid,
      }).then((res) => {
        that.leaveReason = res.data;
      });
    },

    toNew: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });

        return false;
      }
      let leaveTimeType = {};
      let arr = [
        "frontend_unit_as_minutes",
        "n_minutes",
        "full_hour",
        "half_day",
        "day",
      ];
      // 0,15分钟,1,30分钟,2.小时,3,按半天请假4，按天请假
      leaveTimeType["type"] = arr[this.logic];
      if (leaveTimeType["type"] == "half_day") {
        leaveTimeType["params"] = {
          startTime: this.dateTerminal.split(" - ")[0].split(" ")[1],
          endTime: this.dateTerminal.split(" - ")[1].split(" ")[1],
        };
      }
      // if (leaveTimeType["type"] === "day") {
      //   this.defaultEndDate = this.defaultEndDate + " 23:59:59";
      // }
      // console.log(this.defaultEndDate);
      // console.log(this.$getTimeValue(this.defaultEndDate));
      // this.defaultStartDate =
      //   this.defaultStartDate +
      //   (leaveTimeType["type"] === "day" ? " 00:00:00" : "");
      let attachments = [];
      this.ApplicationData.attachment_uuid.map((item) => {
        attachments.push(item["uuid"]);
      });
      let data = {
        applicant_staff_uuid: this.page_params.staff_uuid,
        leave_type_uuid: this.ApplicationData.leave_type_uuid,
        leave_transaction_type_uuid:
          this.ApplicationData.leave_transaction_type_uuid,
        leave_reason_uuid: this.ApplicationData.leave_reason_uuid,
        start_utc_datetime: this.$getTimeValue(this.defaultStartDate),
        start_time_time_zone: this.ApplicationData.start_time_time_zone,
        end_utc_datetime: this.$getTimeValue(this.defaultEndDate),
        end_time_time_zone: this.ApplicationData.end_time_time_zone,
        attachment_uuid: attachments.join(","),
        leave_time_type: leaveTimeType,
        remarks: this.ApplicationData.remarks,
        // sender_uuid: sender.join(","),
        is_overspending_tip: 0,
      };

      this.$Request({
        method: "POST",
        table: "ess_lv_leave_application_record",
        url: "/leave-application/add/",
        data: data,
      })
        .then((res) => {
          that.$showMessage({
            type: "success",
            text: that.$t(
              "message_essweb_myLeaveApplication_form_approvalSuccessLabel"
            ),
          });
          that.$toBack();
        })
        .catch((err) => {});
    },
    toNext: function () {
      this.curStep = this.curStep + 1;
    },
    onInputImage: function (image) {
      // console.log(image);
      this.ApplicationData.attachment_uuid = image;
    },
  },
};
</script>